// extracted by mini-css-extract-plugin
export var divider = "_qa-0";
export var systemMessage = "_qa-1";